import React from 'react';
import * as cls from './certifications.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const items = [
  {
    icon: `${IMG_PATH}/our-technology/hardware/rohs.svg`,
    name: 'RoHS',
    description: 'Restriction of Hazardous Substances compliant',
  },
  {
    icon: `${IMG_PATH}/our-technology/hardware/reach.svg`,
    name: 'REACH',
    description:
      'Registration, Evaluation, Authorisation & Restriction of Chemicals compliant',
  },
  {
    icon: `${IMG_PATH}/our-technology/hardware/emc.svg`,
    name: 'EMC',
    description: 'Electromagnetic Compatibility compliant',
  },
];

export const Certifications = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Why Utilities Run Voltaware Pilots
      </Typography>

      <div className={cls.wrapper}>
        {items.map((item, index) => (
          <div key={index} className={cls.item}>
            <img src={item.icon} alt={`${item.name} compliance badge.`} />
            <Typography>{item.name}</Typography>
            <Typography>{item.description}</Typography>
          </div>
        ))}
      </div>
    </Section>
  );
};
